function Cache() {
    let _cache = Object.create(null);
    let _hitCount = 0;
    let _missCount = 0;
    let _size = 0;
    let _debug = false;

    function _del(key) {
        _size -= 1;
        delete _cache[key];
    }

    this.put = (key, value, options = {}) => {
        const { ttl, onExpire = () => {}, deleteOnExpire = true } = options;

        if (_debug) {
            // eslint-disable-next-line no-console
            console.log('caching: %s = %j (@%s)', key, value, ttl);
        }

        if (typeof ttl !== 'undefined' && (typeof ttl !== 'number' || Number.isNaN(ttl) || ttl <= 0)) {
            throw new Error('Cache timeout must be a positive number');
        } else if (typeof onExpire !== 'undefined' && typeof onExpire !== 'function') {
            throw new Error('Cache timeout callback must be a function');
        }

        const oldRecord = _cache[key];
        if (oldRecord) {
            clearTimeout(oldRecord.timeout);
        } else {
            _size += 1;
        }

        const record = {
            value,
            expire: ttl + Date.now(),
            deleteOnExpire,
        };

        if (!Number.isNaN(record.expire)) {
            record.timeout = setTimeout(async () => {
                if (record.deleteOnExpire) {
                    _del(key);
                }

                if (onExpire) {
                    await onExpire(key, value);
                }
            }, ttl);
        }

        _cache[key] = record;

        return value;
    };

    this.del = (key) => {
        let canDelete = true;

        const oldRecord = _cache[key];
        if (oldRecord) {
            clearTimeout(oldRecord.timeout);
            if (!Number.isNaN(oldRecord.expire) && oldRecord.expire < Date.now()) {
                canDelete = false;
            }
        } else {
            canDelete = false;
        }

        if (canDelete) {
            _del(key);
        }

        return canDelete;
    };

    this.clear = () => {
        Object.values(_cache).forEach((record) => {
            clearTimeout(record.timeout);
        });
        _size = 0;
        _cache = Object.create(null);
        if (_debug) {
            _hitCount = 0;
            _missCount = 0;
        }
    };

    this.get = (key) => {
        const record = _cache[key];
        if (typeof record !== 'undefined') {
            if (Number.isNaN(record.expire) || record.expire >= Date.now() || !record.deleteOnExpire) {
                if (_debug) _hitCount += 1;
                return record.value;
            }

            if (_debug) {
                _missCount += 1;
            }

            // free some space
            _del(key);
        } else if (_debug) {
            _missCount += 1;
        }
        return null;
    };

    this.getIsExpired = (key) => {
        const record = _cache[key];
        return typeof record === 'undefined' || record.expire <= Date.now();
    };

    this.size = () => _size;

    this.memsize = () => Object.keys(_cache).length;

    this.debug = (bool) => {
        _debug = bool;
    };

    this.hits = () => _hitCount;

    this.misses = () => _missCount;

    this.keys = () => Object.keys(_cache);
}

module.exports = new Cache();
module.exports.Cache = Cache;
